import { EventEmitter } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
var CasePracticeCooperationBeginComponent = (function () {
    function CasePracticeCooperationBeginComponent(commonService, apiService) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.onGoToList = new EventEmitter();
        this.onGoToNextStep = new EventEmitter();
    }
    CasePracticeCooperationBeginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/taskBook/' + this.exerciseId
        }).subscribe(function (result) {
            _this.taskBook = result;
        });
    };
    CasePracticeCooperationBeginComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
    };
    CasePracticeCooperationBeginComponent.prototype.close = function () {
        this.onGoToList.emit(true);
    };
    CasePracticeCooperationBeginComponent.prototype.goToNextStep = function () {
        this.onGoToNextStep.emit(3);
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/pnoStorePoint/' + this.exerciseId,
            'data': {
                'pno_store_point_id': 10
            }
        }).subscribe(function (result) { });
    };
    return CasePracticeCooperationBeginComponent;
}());
export { CasePracticeCooperationBeginComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-begin/case-practice-cooperation-begin.component.ts.pre-build-optimizer.js